export enum RegistrationType {
    DEMAND_CREATION = 1,
    DESIGN_REGISTRATION = 2,
}

export const RegistrationTypeName: { [key: number]: string} = {
    [RegistrationType.DEMAND_CREATION]: "Demand Creation",
    [RegistrationType.DESIGN_REGISTRATION]: "Design Registration",
}